export default "__VITE_ASSET__xaMLpGNc__"